import type { Provider } from "../types";

// Placeholder badge -- colored box + first letter. Not a real provider
// logo/trademark asset; swap in proper artwork before this ships broadly.
const PROVIDER_COLORS: Record<string, string> = {
  metrc: "#1f2937",
  biotrack: "#166534",
};

interface ProviderBadgeProps {
  provider: Provider;
  size?: "sm" | "lg";
}

export function ProviderBadge({ provider, size = "sm" }: ProviderBadgeProps) {
  const dimension = size === "lg" ? "w-12 h-12 text-lg" : "w-8 h-8 text-sm";
  const color = PROVIDER_COLORS[provider.id] || "#374151";

  return (
    <div
      className={`${dimension} flex items-center justify-center rounded-full text-white font-semibold flex-shrink-0`}
      style={{ backgroundColor: color }}
      aria-hidden="true"
    >
      {provider.name.charAt(0).toUpperCase()}
    </div>
  );
}
